import {
  UserToken as UserTokenDomainModeType,
  IUser as IUserDomainModelType
} from '../models/user';
export type UserToken = UserTokenDomainModeType;

export type IUser = IUserDomainModelType;

export const author1: IUser = {
  id: 'b00be7df-ee69-469b-a61f-330a28e998b6',
  firstName: 'A.Matthew',
  lastName: 'Lewis',
  email: 'lewis.bnj.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0001',
  realm: 'bnj',
  status: 'active'
};

const author1Prod: IUser = {
  ...author1,
  id: 'da5a76c8-0d63-4afc-b89d-3fb3282760a6'
};

const editor1: IUser = {
  id: 'cbd0b4d9-6f13-4012-8374-016a2d06db15',
  firstName: 'E.Rodger',
  lastName: 'Stancy',
  email: 'stancy.bnj.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0002',
  realm: 'bnj',
  status: 'active'
};

const editor1Prod: IUser = {
  ...editor1,
  id: '9e7f9b96-e6ed-4e77-82c0-cf86b1da5176'
};

const editor2: IUser = {
  id: 'd9ca6d8e-3e56-47d6-bb44-52a929eab1da',
  firstName: 'E.Amina',
  lastName: 'Patel',
  email: 'patel.bnj.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0003',
  realm: 'bnj',
  status: 'active'
};

const editor2Prod: IUser = {
  ...editor2,
  id: 'be67cbe5-c387-4ad0-8765-4da159eab4f8'
};

const editor3: IUser = {
  id: '1da6c763-80d8-49c3-9b1d-0f0bbadd7065',
  firstName: 'E.Diego',
  lastName: 'Alvarez',
  email: 'alvarez.bnj.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0004',
  realm: 'bnj',
  status: 'active'
};

const editor3Prod: IUser = {
  ...editor3,
  id: '2dae0581-53a0-4cad-9719-5691454e3eeb'
};

const editor4: IUser = {
  id: '8bfb1648-9752-4097-9004-e953b1589b57',
  firstName: 'E.Chen',
  lastName: 'Wei',
  email: 'wei.bnj.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0005',
  realm: 'bnj',
  status: 'active'
};

const editor4Prod: IUser = {
  ...editor4,
  id: 'a88c1296-3dfa-4262-a875-f829cd44f774'
};

const reviewer2: IUser = {
  id: '6de0051e-2134-405a-b981-9cde1217d409',
  firstName: 'R.John',
  lastName: 'Doe',
  email: 'doe.bnj.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0006',
  realm: 'bnj',
  status: 'active'
};

const reviewer2Prod: IUser = {
  ...reviewer2,
  id: '2e17bf3a-9add-4ee6-9967-391b432fb17f'
};

const reviewer3: IUser = {
  id: '035a7334-fbf7-4ad3-8ef1-5e919a2cb26b',
  firstName: 'R.Monalisa',
  lastName: 'Paine',
  email: 'paine.bnj.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0007',
  realm: 'bnj',
  status: 'active'
};

const reviewer3Prod: IUser = {
  ...reviewer3,
  id: 'd8a4e235-4a47-4b28-8aa0-96a3c66d3b16'
};

const reviewer1: IUser = {
  id: '32338f6b-fe17-4c42-8588-c043f71971df',
  firstName: 'R.Teniola',
  lastName: 'Page',
  email: 'page.bnj.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0008',
  realm: 'bnj',
  status: 'active'
};

const reviewer1Prod: IUser = {
  ...reviewer1,
  id: '5f9836e5-e71a-4e4e-b23c-284dfc4f7c63'
};

const orgAdmin1: IUser = {
  id: '86739f61-4d17-4a2c-a63f-5a2f5ac15836',
  firstName: 'O.Oscar',
  lastName: 'Odin',
  email: 'odin.bnj.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0009',
  realm: 'bnj',
  status: 'active'
};

const editor5: IUser = {
  id: '306e9a85-d95f-4888-9457-a1f5063584df',
  firstName: 'A.Aiden',
  lastName: 'Cruz',
  email: 'aiden.bnj.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0009',
  realm: 'bnj',
  status: 'active'
};

const editor5Prod: IUser = {
  ...editor5,
  id: '4be14459-e14b-4f8b-8e40-cd2c3e2c5ae9'
};

const editor6: IUser = {
  id: '7b21ef71-267c-4076-a5c6-4af07c4d9e03',
  firstName: 'C.Charlotte',
  lastName: 'Davis',
  email: 'charlotte.bnj.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0009',
  realm: 'bnj',
  status: 'active'
};
const editor6Prod: IUser = {
  ...editor6,
  id: '4c2990b6-e926-4a7d-977a-774cd96509ef'
};

const editor7: IUser = {
  id: '650f907a-bde8-49bd-a2cf-dc422454a311',
  firstName: 'S.Simon',
  lastName: 'Clarke',
  email: 'simon.bnj.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0009',
  realm: 'bnj',
  status: 'active'
};

const editor7Prod: IUser = {
  ...editor7,
  id: '046ce2dc-bcf4-4211-9618-bd4921cb4176'
};

const orgAdmin1Prod: IUser = {
  ...orgAdmin1,
  id: '6e3f5de0-7e14-4568-8b5c-25e1cff31450'
};

const sysAdmin1: IUser = {
  id: '2e79031d-8a48-4640-b8bc-5ddb3f0d7c1a',
  firstName: 'Sudo',
  lastName: 'User',
  email: 'sudo.bnj.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0010',
  realm: 'bnj',
  status: 'active'
};

const sysAdmin1Prod: IUser = {
  ...sysAdmin1,
  id: '844ee6ec-be6d-4546-8d3c-48f74b77c6f3'
};

const boardMember1: IUser = {
  id: '08a8313d-f9ff-43b0-9468-ea5e88259e14',
  firstName: 'B.Benjamin',
  lastName: 'Clark',
  email: 'bclark.board.bnj.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0011',
  realm: 'bnj',
  status: 'active'
};

const boardMember1Prod: IUser = {
  ...boardMember1,
  id: '334911a4-6fcd-4ff0-894f-00c2f664f67a'
};

const boardMember2: IUser = {
  id: 'f6826ab2-459c-4618-8e53-dfa6ddf325c5',
  firstName: 'B.Bianca',
  lastName: 'Rivera',
  email: 'brivera.board.bnj.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0012',
  realm: 'bnj',
  status: 'active'
};

const boardMember2Prod: IUser = {
  ...boardMember2,
  id: '8012465a-ce95-4497-b1d2-b6768b27a434'
};

const boardMember3: IUser = {
  id: '6ead7b38-1f17-49b3-ad8a-563350b33e1b',
  firstName: 'B.Brianna',
  lastName: 'Patel',
  email: 'bpatel.board.bnj.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0013',
  realm: 'bnj',
  status: 'active'
};

const boardMember3Prod: IUser = {
  ...boardMember3,
  id: 'd9ae0ee3-d741-421d-802c-00102bcb69b4'
};

export const STAGING_USERS_MAP = {
  author1,
  editor1,
  editor2,
  editor3,
  editor4,
  reviewer1,
  reviewer2,
  reviewer3,
  boardMember1,
  boardMember2,
  boardMember3,
  orgAdmin1,
  sysAdmin1,
  editor5,
  editor6,
  editor7
} as const;

export const STAGING_REVIEWERS = {
  reviewer1,
  reviewer2,
  reviewer3
} as const;

export const PROD_USERS_MAP = {
  author1: author1Prod,
  editor1: editor1Prod,
  editor2: editor2Prod,
  editor3: editor3Prod,
  editor4: editor4Prod,
  editor5: editor5Prod,
  editor6: editor6Prod,
  editor7: editor7Prod,
  reviewer1: reviewer1Prod,
  reviewer2: reviewer2Prod,
  reviewer3: reviewer3Prod,
  boardMember1: boardMember1Prod,
  boardMember2: boardMember2Prod,
  boardMember3: boardMember3Prod,
  orgAdmin1: orgAdmin1Prod,
  sysAdmin1: sysAdmin1Prod
} as const;

export const STAGING_BOARDMEBMERS = {
  boardMember1,
  boardMember2,
  boardMember3
} as const;
